
import { Vue } from 'nuxt-property-decorator'

export default class IconClose extends Vue {}
